/*
 * SafeWall FAQ (sections/sw-faq.liquid): one answer open at a time, opening and closing with a short
 * height animation. Each question is a <details>; a click on its <summary> is taken over here.
 * The items share a <details name>, which already keeps one open without this script. It's removed
 * here, because the browser would close the other item instantly, before its closing animation.
 * With reduced motion, items open and close without animation.
 */
(function () {
  'use strict';

  var DURATION = 250;
  var EASING = 'cubic-bezier(0.2, 0, 0, 1)';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function release(list) {
    if (list.__swFaq) return;
    list.__swFaq = true;
    list.querySelectorAll('.sw-faq__item[name]').forEach(function (item) { item.removeAttribute('name'); });
  }

  function finish(item, answer, open) {
    item._swAnim = null;
    item.open = open;
    item.classList.remove('is-closing');
    answer.style.overflow = '';
  }

  function frame(answer) {
    var cs = getComputedStyle(answer);
    return { height: answer.getBoundingClientRect().height + 'px', marginTop: cs.marginTop, paddingBottom: cs.paddingBottom };
  }

  function toggle(item, open) {
    var answer = item.querySelector('.sw-faq__a');
    if (!answer || reduce.matches || !answer.animate) {
      if (item._swAnim) item._swAnim.cancel();
      finish(item, answer || item, open);
      return;
    }

    var closed = { height: '0px', marginTop: '0px', paddingBottom: '0px' };
    // Start from where the answer is now: closed, open, or part-way through an animation
    var start = item.open ? frame(answer) : closed;
    if (item._swAnim) item._swAnim.cancel();
    item.classList.toggle('is-closing', !open);
    item.open = true;
    var full = frame(answer);

    answer.style.overflow = 'hidden';
    var anim = answer.animate([start, open ? full : closed], { duration: DURATION, easing: EASING });
    item._swAnim = anim;
    anim.onfinish = function () { finish(item, answer, open); };
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.sw-faq__q');
    if (!summary) return;
    var item = summary.parentElement;
    var list = item && item.closest('.sw-faq__list');
    if (!list) return;
    e.preventDefault();
    release(list);

    var opening = !item.open || item.classList.contains('is-closing');
    if (opening) {
      list.querySelectorAll('.sw-faq__item[open]').forEach(function (other) {
        if (other !== item && !other.classList.contains('is-closing')) toggle(other, false);
      });
    }
    toggle(item, opening);
  });
})();
